
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_qk1j1_17teb_141",
  "textarea": "awsui_textarea_qk1j1_17teb_145",
  "textarea-resize-both": "awsui_textarea-resize-both_qk1j1_17teb_196",
  "textarea-resize-horizontal": "awsui_textarea-resize-horizontal_qk1j1_17teb_199",
  "textarea-resize-vertical": "awsui_textarea-resize-vertical_qk1j1_17teb_202",
  "textarea-resize-none": "awsui_textarea-resize-none_qk1j1_17teb_205",
  "textarea-readonly": "awsui_textarea-readonly_qk1j1_17teb_214",
  "textarea-invalid": "awsui_textarea-invalid_qk1j1_17teb_255",
  "textarea-warning": "awsui_textarea-warning_qk1j1_17teb_264"
};
  